<template>
  <div class="page padding">
    <filtros-cartera ref="filtersForm" v-model="filter" @change="getPoliciesFirstTime" @tableChange="filterReset" />

    <table-cartera
      v-if="filterSetted"
      clickable
      :tableName="filter.tableName"
      :records="records"
      :perPage="recordsPerPage"
      :columns="columns"
      :data="policies"
      :loading="loading"
      :client-side-treat="clientSideTreat"
      @pageChange="setStart"
      @exportReport="showExportReportModal"
      @sorted="getPolicies"
    />

    <!-- Aca va el modal para exportar reportes en Cartera -->
    <b-modal v-model="showReportModal" ref="modal" title="Exportar Reportes - Pólizas Cartera">

      <p class="mx-3 my-2">
        <b>Formato de reporte: </b>
      </p>
      <b-select :options="tiposReportes" class="mb-2" v-model="tipoReporte" />

      <!-- Aca irian las columnas disponibles por modulo de cartera para generar el reporte -->
      <p class="mx-3 my-2">
        <b>Propiedades a mostar en el reporte: </b>
      </p>

      <div v-for="propiedad in listaPropiedadesPolizas" :key="propiedad.value">
          <label><input type="checkbox" v-model="propiedadesPolizasElegidas" :value="propiedad"/> {{propiedad.title}}</label>&nbsp;
      </div>

      <template #modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" :disabled="!hayPropiedadesElegidas" @click="download(tipoReporte)">
          Exportar Reporte
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">
          Cancelar
        </b-button>
      </template>

    </b-modal>

  </div>
</template>

<script>
import FiltrosCartera from '@/components/Cartera/FiltrosCartera.vue';
import TableCartera from '@/components/Cartera/TableCartera.vue';
import { PolizasEndososColumns, AvisosVencimientoColumns, RefacturacionesColumns, PolizasDeudaColumns, PolizasAnuladasColumns } from './columns.js';
import moment from 'moment';

export default {
  components: {
    FiltrosCartera,
    TableCartera,
  },
  data() {
    return {
      policies: [],
      records: 0,
      recordsPerPage: 10,
      currentPage: 1,
      loading: false,
      table: 0,
      columns: [],
      clientSideTreat: false,
      currentEndpoint: '',
      filterSetted: false,
      filter: {},
      showReportModal: false,
      tipoReporte: 'pdf',
      tiposReportes: [
        { text: 'PDF', value: 'pdf' },
        { text: 'TXT', value: 'txt' },
        { text: 'XLS', value: 'xls' },
        { text: 'CSV', value: 'csv' },
        
      ],
      nombreModulo: '',
      listaPropiedadesPolizas: [],
      propiedadesPolizasElegidas: [],
      nombrePropiedadesPolizasEndosos: [
        { title: "Asegurado", label: "Asegurado", value: "asegurado", type: null, checked: true },
        { title: "Código Agente", label: "Cod. Agente", value: "cod_agente", type: null, checked: false },
        { title: "Código Ramo", label: "Cod. Ramo", value: "cod_ramo", type: null, checked: false },
        { title: "Datos Tomador", label: "Documentos", value: "datos_tomador", type: null, checked: false },
        { title: "Fecha de Emisión", label: "Emision", value: "fec_emi", type: "date", checked: true },
        { title: "Vigencia Desde", label: "V.Desde", value: "fec_vig_desde", type: "date", checked: true },
        { title: "Vigencia Hasta", label: "V.Hasta", value: "fec_vig_hasta", type: "date", checked: true },
        { title: "Conducto de Pago", label: "Conducto", value: "forma_pago", type: null, checked: true },
        { title: "Cod. Tomador", label: "Cod. Tom.", value: "id_tomador", type: null, checked: false },
        { title: "Suma", label: "Suma", value: "imp_suma_asegurada", type: "numeric", checked: true },
        { title: "Nro. Endoso", label: "End.", value: "nro_endoso", type: null, checked: true },
        { title: "Nro. Póliza", label: "Poliza", value: "nro_pol", type: null, checked: true },
        { title: "Premio", label: "Premio", value: "premio", type: "numeric", checked: true },
        { title: "Prima", label: "Prima", value: "prima", type: "numeric", checked: true },
        { title: "Ramo", label: "Ramo", value: "ramo", type: null, checked: true },
        { title: "Tomador", label: "Tomador", value: "tomador", type: null, checked: true },
        { title: "Productor", label: "Productor", value: "txt_nombre_productor", type: null, checked: false },
      ],
      nombrePropiedadesPolizasPorVencer: [
        { title: "Asegurado", label: "Asegurado", value: "asegurado", type: null, checked: true },
        { title: "Código Ramo", label: "Cod. Ramo", value: "cod_ramo", type: null, checked: false },
        { title: "Fecha de Emisión", label: "Emision", value: "fec_emi", type: "date", checked: true },
        { title: "Vigencia Desde", label: "V.Desde", value: "fec_vig_desde", type: "date", checked: true },
        { title: "Vigencia Hasta", label: "V.Hasta", value: "fec_vig_hasta", type: "date", checked: true },
        { title: "Conducto de Pago", label: "Conducto", value: "forma_pago", type: null, checked: true },
        { title: "Cod. Tomador", label: "Cod. Tom.", value: "id_tomador", type: null, checked: false },
        { title: "Nro. Endoso", label: "End.", value: "nro_endoso", type: null, checked: true },
        { title: "Nro. Póliza", label: "Poliza", value: "nro_pol", type: null, checked: true },
        { title: "Premio", label: "Premio", value: "premio", type: "numeric", checked: true },
        { title: "Prima", label: "Prima", value: "prima", type: "numeric", checked: true },
        { title: "Ramo", label: "Ramo", value: "ramo", type: null, checked: true },
        { title: "Suma", label: "Suma", value: "suma", type: null, checked: true  },
        { title: "Tomador", label: "Tomador", value: "tomador", type: null, checked: true },
      ],
      nombrePropiedadesRefacturacionesRC: [
        { title: "Asegurado", label: "Asegurado", value: "asegurado", type: null, checked: true },
        { title: "Cantidad de Cuota", label: "Cant.Cuota", value: "CANT_CUOTA", type: null, checked: false },
        { title: "Código Agente", label: "Cod. Agente", value: "cod_agente", type: null, checked: false },
        { title: "Código Ramo", label: "Cod. Ramo", value: "cod_ramo", type: null, checked: false },
        { title: "Vigencia Desde", label: "V.Desde", value: "fec_vig_desde", type: "date", checked: true },
        { title: "Vigencia Hasta", label: "V.Hasta", value: "fec_vig_hasta", type: "date", checked: true },
        { title: "Conducto de Pago", label: "Conducto", value: "forma_pago", type: null, checked: true },
        { title: "Cod. Tomador", label: "Cod. Tom.", value: "id_tomador", type: null, checked: false },
        { title: "Nro. Endoso", label: "End.", value: "nro_endoso", type: null, checked: true },
        { title: "Nro. Póliza", label: "Poliza", value: "nro_pol", type: null, checked: true },
        { title: "Premio", label: "Premio", value: "premio", type: "numeric", checked: true },
        { title: "Prima", label: "Prima", value: "prima", type: "numeric", checked: true },
        { title: "Ramo", label: "Ramo", value: "ramo", type: null, checked: true },
        { title: "Suma", label: "Suma", value: "suma", type: null, checked: true },
        { title: "Tomador", label: "Tomador", value: "tomador", type: null, checked: true },
        { title: "Periodo", label: "Periodo", value: "txt_periodo", type: null, checked: false },
      ],
      nombrePropiedadesRefacturacionesPer: [
        { title: "Asegurado", label: "Asegurado", value: "asegurado", type: null, checked: true },
        { title: "Código Agente", label: "Cod. Agente", value: "cod_agente", type: null, checked: false },
        { title: "Fecha de Emisión", label: "Emision", value: "fec_emi", type: "date", checked: true },
        { title: "Vigencia Desde", label: "V.Desde", value: "fec_vig_desde", type: "date", checked: true },
        { title: "Vigencia Hasta", label: "V.Hasta", value: "fec_vig_hasta", type: "date", checked: true },
        { title: "Conducto de Pago", label: "Conducto", value: "forma_pago", type: null, checked: true },
        { title: "Cod. Tomador", label: "Cod. Tom.", value: "id_tomador", type: null, checked: false },
        { title: "Nro. Endoso", label: "End.", value: "nro_endoso", type: null, checked: true },
        { title: "Nro. Póliza", label: "Poliza", value: "nro_pol", type: null, checked: true },
        { title: "Premio", label: "Premio", value: "premio", type: "numeric", checked: true },
        { title: "Prima", label: "Prima", value: "prima", type: "numeric", checked: true },
        { title: "Ramo", label: "Ramo", value: "ramo", type: null, checked: true },
        { title: "Suma", label: "Suma", value: "suma", type: null, checked: true },
        { title: "Tomador", label: "Tomador", value: "tomador", type: null, checked: true },
      ],
      nombrePropiedadesPolizasConDeuda: [
        { title: "Asegurado", label: "Asegurado", value: "asegurado", type: null, checked: true },
        { title: "Deuda", label: "Deuda", value: "deuda", type: "numeric", checked: true },
        { title: "Fecha de Emisión", label: "Emision", value: "fec_emi", type: "date", checked: true },
        { title: "Vigencia Desde", label: "V.Desde", value: "fec_vig_desde", type: "date", checked: true },
        { title: "Vigencia Hasta", label: "V.Hasta", value: "fec_vig_hasta", type: "date", checked: true },
        { title: "Conducto de Pago", label: "Conducto", value: "forma_pago", type: null, checked: true },
        { title: "Cod. Tomador", label: "Cod. Tom.", value: "id_tomador", type: null, checked: false },
        { title: "Nro. Endoso", label: "End.", value: "nro_endoso", type: null, checked: true },
        { title: "Nro. Póliza", label: "Poliza", value: "nro_pol", type: null, checked: true },
        { title: "Premio", label: "Premio", value: "premio", type: "numeric", checked: true },
        { title: "Prima", label: "Prima", value: "prima", type: "numeric", checked: true },
        { title: "Ramo", label: "Ramo", value: "ramo", type: null, checked: true },
        { title: "Tomador", label: "Tomador", value: "tomador", type: null, checked: true },
      ],
      nombrePropiedadesPolizasAnuladasRC: [
        { title: "Asegurado", label: "Asegurado", value: "asegurado", type: null, checked: true },
        { title: "Cantidad de Cuota", label: "Cant.Cuota", value: "CANT_CUOTA", type: null, checked: false },
        { title: "Código Agente", label: "Cod. Agente", value: "cod_agente", type: null, checked: false },
        { title: "Código Ramo", label: "Cod. Ramo", value: "cod_ramo", type: null, checked: false },
        { title: "Fecha de Emisión", label: "Emision", value: "fec_emi", type: "date", checked: true },
        { title: "Vigencia Desde", label: "V.Desde", value: "fec_vig_desde", type: "date", checked: true },
        { title: "Vigencia Hasta", label: "V.Hasta", value: "fec_vig_hasta", type: "date", checked: true },
        { title: "Conducto de Pago", label: "Conducto", value: "forma_pago", type: null, checked: true },
        { title: "Cod. Tomador", label: "Cod. Tom.", value: "id_tomador", type: null, checked: false },
        { title: "Nro. Endoso", label: "End.", value: "nro_endoso", type: null, checked: true },
        { title: "Nro. Póliza", label: "Poliza", value: "nro_pol", type: null, checked: true },
        { title: "Premio", label: "Premio", value: "premio", type: "numeric", checked: true },
        { title: "Prima", label: "Prima", value: "prima", type: "numeric", checked: true },
        { title: "Ramo", label: "Ramo", value: "ramo", type: null, checked: true },
        { title: "Suma", label: "Suma", value: "suma", type: null, checked: true },
        { title: "Tomador", label: "Tomador", value: "tomador", type: null, checked: true },
      ],
      nombrePropiedadesPolizasAnuladasPer: [
        { title: "Asegurado", label: "Asegurado", value: "asegurado", type: null, checked: true },
        { title: "Cantidad de Cuota", label: "Cant.Cuota", value: "CANT_CUOTA", type: null, checked: false },
        { title: "Código Ramo", label: "Cod. Ramo", value: "cod_ramo", type: null, checked: false },
        { title: "Fecha de Emisión", label: "Emision", value: "fec_emi", type: "date", checked: true },
        { title: "Vigencia Desde", label: "V.Desde", value: "fec_vig_desde", type: "date", checked: true },
        { title: "Vigencia Hasta", label: "V.Hasta", value: "fec_vig_hasta", type: "date", checked: true },
        { title: "Conducto de Pago", label: "Conducto", value: "forma_pago", type: null, checked: true },
        { title: "Cod. Tomador", label: "Cod. Tom.", value: "id_tomador", type: null, checked: false },
        { title: "Nro. Endoso", label: "End.", value: "nro_endoso", type: null, checked: true },
        { title: "Nro. Póliza", label: "Poliza", value: "nro_pol", type: null, checked: true },
        { title: "Productor", label: "Productor", value: "Pas", type: null, checked: false },
        { title: "Premio", label: "Premio", value: "premio", type: "numeric", checked: true },
        { title: "Prima", label: "Prima", value: "prima", type: "numeric", checked: true },
        { title: "Suma", label: "Suma", value: "suma", type: null, checked: true },
        { title: "Tomador", label: "Tomador", value: "tomador", type: null, checked: true },
      ],
    };
  },
  methods: {
    getPoliciesFirstTime () {
      this.filter.start = 0;
      this.getPolicies();
    },
    /**
     * @param Number table Número entero que representa la tabla a consultar:
     * 0 - pólizas y endosos
     * 1 - avisos de vencimiento
     * 2 - refacturaciones
     * 3 - pólizas con deuda
     * 4 - pólizas anuladas
     */
    getPolicies: async function () {
      this.filterSetted = true;
      this.policies = [];
      this.loading = true;

      const tableIndex = this.filter.tableIndex;
      if (tableIndex === 0) {
        // 0 - polizas y endosos
        this.columns = PolizasEndososColumns;
        this.clientSideTreat = false;
        this.currentEndpoint = 'polizas-endosos';
        await this.request('polizas-endosos');
      } else if (tableIndex === 1) {
        // 1 - avisos de vencimiento
        this.columns = AvisosVencimientoColumns;
        this.clientSideTreat = false;
        this.currentEndpoint = 'avisos-vencimiento';
        await this.request('avisos-vencimiento');
      } else if (tableIndex === 2) {
        // 2 - refacturaciones
        // En este caso, los ramos son los de rc_profesional y PER

        this.columns = RefacturacionesColumns;
        this.clientSideTreat = true;

        var endpoint = 'refacturaciones/rcprof';
        if (this.filter.ramo != 'rc_profesional') {

          endpoint = 'refacturaciones/per';
          if (!this.filter.refac_hasta) {
            this.filter.refac_hasta = moment().endOf('month').format('Y-MM-DD');
          }

        } else {

          if (!this.filter.refac_desde) {
            this.filter.refac_desde = moment().date(11).format('Y-MM-DD');
          }
          if (!this.filter.refac_hasta) {
            this.filter.refac_hasta = moment().date(10).add(1, 'months').format('Y-MM-DD');
          }

        }

        this.currentEndpoint = endpoint;
        await this.request(endpoint);
      } else if (tableIndex === 3) {
        // 3 - polizas con deuda
        this.clientSideTreat = false;
        this.columns = PolizasDeudaColumns;
        this.currentEndpoint = 'polizas-con-deuda';
        await this.request('polizas-con-deuda');
      } else if (tableIndex === 4) {
        // 4 - pólizas anuladas
        this.columns = PolizasAnuladasColumns;
        this.clientSideTreat = true;
        let endpoint = 'polizas-anuladas-rc';
        if (this.filter.ramo != 'rc_profesional') {
          endpoint = 'polizas-anuladas-per';
        }
        this.currentEndpoint = endpoint;
        await this.request(endpoint);
      }

      this.loading = false;
    },
    request(endpoint, extension = false) {

      if (!this.filter.search || !this.filter.search.length) delete this.filter.search;
      if (!extension) {
        this.filter.output = null;

        if ( this.filter.cod_agente=="") { // Si es un productor o un organizador o grupo norte no puede pedir ningun cod_agente
          if ( this.$role(['Productor']) || this.$role(['Organizador']) || this.$role(['grupo norte']) ) {
            this.filter.cod_agente = this.$store.state.auth.cod_agente;
          }
        }

        return this.$api.post(`cartera/${endpoint}`, this.filter).then((res) => {
          this.records = res.data.total_rows;
          this.policies = res.data.results;
        });
      } else {
        this.filter.output = extension;
        this.filter.columnasParaReporte = this.propiedadesPolizasElegidas

        return this.$api({
          url: `cartera/${endpoint}`,
          method: 'POST',
          data: this.filter,
          responseType: 'blob',
          headers: {
            ContentType: 'multipart/form-data',
          },
        })
          .then((res) => {
            var downloadLink = document.createElement('a');
            document.body.appendChild(downloadLink)
            downloadLink.style="display: none"
            const fileURL = URL.createObjectURL(res.data);
            downloadLink.href = fileURL;

            let codAgente = ''
            if (this.$role(['empleado interno']) || this.$role(['organizador'])) {
              codAgente = this.filter.cod_agente ? this.filter.cod_agente : 'GENERAL'
            }else{
              codAgente = this.$store.state.auth.cod_agente
            }

            downloadLink.download = codAgente + '-CARTERA-' + this.nombreModulo + '.' + extension;
            downloadLink.click();
            window.URL.revokeObjectURL(fileURL);
            document.body.removeChild(downloadLink);
          })
          .catch((err) => {
            this.loading = false;
            const toast = this.$toast;
            const fr = new FileReader();
            fr.onload = function () {
              toast.error(fr.result);
            };
            fr.readAsText(err.response.data);
          });
      }
    },
    setStart(n) {
      //this.filter.start = n * this.recordsPerPage + 1;
      this.filter.start = n * this.recordsPerPage;
      this.getPolicies(this.$store.state.selectedTableCartera);
    },
    download: async function (extension) {
      //const loader = this.$loading.show();
      /*//console.log(this.filter);
      return;*/
      if (this.records >2000 && extension == 'pdf'){
        this.$toast.error('La cantidad de registros excede el límite, 2000 registros, soportado por este formato, intente con otro tipo de archivo.', 'Error');
        return;
      }
      await this.request(this.currentEndpoint, extension);
      //loader.hide();
    },
    showExportReportModal() {
      this.showReportModal = true
    },
    filterReset(payload) {
      this.policies = [];
      (this.records = 0), (this.filterSetted = false);
    },
    cargarPropiedadesDeTabla() {
      this.propiedadesPolizasElegidas = this.listaPropiedadesPolizas.filter(e => e.checked == true)
    },
  },
  computed: {
    hayPropiedadesElegidas() {
      if (this.propiedadesPolizasElegidas.length > 0) return true
      return false
    }
  },
  created: async function () {
    if (this.$can(['Solo RCP'])) this.filter.cod_ramo = 80;

    if (this.$role(['Productor'])) {
      this.filter.cod_agente = this.$store.state.auth.cod_agente;
      this.filter.cod_tipo_agente = this.$store.state.auth.cod_tipo_agente;
      this.filter.type_user = this.$store.state.auth.role.roles[0].name;
    }
  },
  mounted() {
    this.filter = this.$store.state.filterCartera;
    const autosearch = this.filter.autosearch;
    if (autosearch) {
      this.$refs.filtersForm.filterAccordionVisible = false;
      this.getPolicies(this.filter.tableIndex);
      this.filter.autosearch = false;
    }
  },
  watch: {
    'filter.tableIndex': function(newValue) {
      switch(newValue) {
        case 0:
          this.listaPropiedadesPolizas = this.nombrePropiedadesPolizasEndosos
          this.cargarPropiedadesDeTabla()
          this.nombreModulo = "POLIZASYENDOSOS"
          break
        case 1:
          this.listaPropiedadesPolizas = this.nombrePropiedadesPolizasPorVencer
          this.cargarPropiedadesDeTabla()
          this.nombreModulo = "POLIZASAVENCER"
          break
        case newValue == 2 && this.filter.ramo == 'rc_profesional':
          this.listaPropiedadesPolizas = this.nombrePropiedadesRefacturacionesRC
          this.cargarPropiedadesDeTabla()
          this.nombreModulo = "REFACTURACIONESRC"
          break
        case newValue == 2 && this.filter.ramo == 'PER':
          this.listaPropiedadesPolizas = this.nombrePropiedadesRefacturacionesPer
          this.cargarPropiedadesDeTabla()
          this.nombreModulo = "REFACTURACIONESPER"
          break
        case 3:
          this.listaPropiedadesPolizas = this.nombrePropiedadesPolizasConDeuda
          this.cargarPropiedadesDeTabla()
          this.nombreModulo = "POLIZASCONDEUDA"
          break
        case newValue == 4 && this.filter.ramo == 'rc_profesional':
          this.listaPropiedadesPolizas = this.nombrePropiedadesPolizasAnuladasRC
          this.cargarPropiedadesDeTabla()
          this.nombreModulo = "POLIZASANULADASRC"
          break
        case newValue == 4 && this.filter.ramo == 'PER':
          this.listaPropiedadesPolizas = this.nombrePropiedadesPolizasAnuladasPer
          this.cargarPropiedadesDeTabla()
          this.nombreModulo = "POLIZASANULADASPER"
          break
      }
    },
    'filter.ramo': function(newValue) {
      if(this.filter.tableIndex == 2){
        if(newValue == 'rc_profesional'){
          this.listaPropiedadesPolizas = this.nombrePropiedadesRefacturacionesRC
          this.cargarPropiedadesDeTabla()
          this.nombreModulo = "REFACTURACIONESRC"
        }else if(newValue == 'PER'){
          this.listaPropiedadesPolizas = this.nombrePropiedadesRefacturacionesPer
          this.cargarPropiedadesDeTabla()
          this.nombreModulo = "REFACTURACIONESPER"
        }
      }else if(this.filter.tableIndex == 4){
        if(newValue == 'rc_profesional'){
          this.listaPropiedadesPolizas = this.nombrePropiedadesPolizasAnuladasRC
          this.cargarPropiedadesDeTabla()
          this.nombreModulo = "POLIZASANULADASRC"
        }else if(newValue == 'PER'){
          this.listaPropiedadesPolizas = this.nombrePropiedadesPolizasAnuladasPer
          this.cargarPropiedadesDeTabla()
          this.nombreModulo = "POLIZASANULADASPER"
        }
      }
    },

  }
};
</script>
